export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  lifecycle: { asc: 'Planned \u2192 Completed', desc: 'Completed \u2192 Planned' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
  currency: { asc: 'Lowest \u2192 Highest', desc: 'Highest \u2192 Lowest' },
};
